<template>
  <div>
    <accordion-component>
      <template v-slot:header>
        {{ $t('W2P_UPLOAD_LETTER_HOW_TO_TITLE') }}
      </template>
      <template v-slot:content>
        <div class="upload-letter-instruction">
          <ul>
            <li>{{ $t('W2P_UPLOAD_LETTER_HOW_TO_BODY_1') }}</li>
            <li>{{ $t('W2P_UPLOAD_LETTER_HOW_TO_BODY_2') }}</li>
            <li>{{ $t('W2P_UPLOAD_LETTER_HOW_TO_BODY_3') }}</li>
            <li>{{ $t('W2P_UPLOAD_LETTER_HOW_TO_BODY_4') }}</li>
            <li>{{ $t('W2P_UPLOAD_LETTER_HOW_TO_BODY_5') }}</li>
          </ul>
          <img :src="require('@/assets/images/letter_template.png')" />
        </div>
      </template>
    </accordion-component>
  </div>
</template>

<script>
import AccordionComponent from '@/components/common/accordion/AccordionComponent'

export default {
  components: {
    AccordionComponent
  }
}
</script>

<style lang="scss">
.upload-letter-instruction {
  ul {
    padding: 0 1em;
  }
}

@media screen and (max-width: 50em) {
  .upload-letter-instruction {
    img {
      width: 100%;
    }
  }
}
</style>
